import React, { useEffect, useRef } from 'react';
import Label from './fromLabel';
import Error from './fromError';
import Icon from '../../icons';
import Button from "../../../components/elements/button";
import toast from 'react-hot-toast';
import ModalWrapper from '../../modalWrapper';
import Camera from '../../camera';


interface InputProps {
    isMulti?: boolean;
    accept?: string;
    placeholder?: string;
    value?: any;
    onChange: (e: any, files?: Array<File>) => void;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    info?: string;
    error?: string;
    isFigmaType?: boolean; // Optional prop to handle Figma file uploads
    allowedExt?: string[]; // Optional prop to handle allowed file extensions
    retainFiles?: boolean;
    className?: string;
    useEmbedMobileCam?: boolean;
    maxSize?: number; // Optional prop to set maximum file size in MB
}

const FileUpload: React.FC<InputProps> = ({ placeholder, value, onChange, disabled = false, label, required, info, error, accept = '*', isMulti = false, isFigmaType = false, allowedExt = [], retainFiles = false, className = ``, useEmbedMobileCam = false, maxSize }) => {

    const inputRef: any = useRef();
    const dragarea: any = useRef();
    const cameramodalRef: any = useRef();

    interface PreviewItem {
        name: string;
        mimetype: string;
        ext: string;
        src: string | null;
    }

    const [imagePreview, setImagePreview] = React.useState<PreviewItem[]>([]);
    const [selectdFilessource, setSelectedFilesSource] = React.useState<any>([]);
    const [isCameraAvailable, setIsCameraAvailable] = React.useState<boolean>(false);

    const removeFile = (index: number) => {
        const updatedPreview = imagePreview.filter((_, i) => i !== index);
        const updatedSourceFiles = selectdFilessource.filter((_: any, i: number) => i !== index);
        
        setImagePreview(updatedPreview);
        setSelectedFilesSource(updatedSourceFiles);
        onChange({ target: { files: updatedSourceFiles } }, updatedSourceFiles);
    };

    const isMobileDevice = (): boolean => {
        if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
        const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
        return /android|iphone|ipad|ipod/i.test(ua);
    };

    const formatFileSize = (bytes: number): string => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const validateFileSize = (file: File): boolean => {
        if (maxSize && file.size > maxSize * 1024 * 1024) {
            toast.error(`${file.name} - File size (${formatFileSize(file.size)}) exceeds the maximum allowed size of ${maxSize}MB`);
            return false;
        }
        return true;
    };

    const hasCameraAttached = async (): Promise<boolean> => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            return false;
        }
        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            return devices.some(device => device.kind === 'videoinput');
        } catch {
            return false;
        }
    };

    useEffect(() => {
        hasCameraAttached().then((hasCamera) => {
            setIsCameraAvailable(hasCamera ? true : false);
        });
    }, []);

    useEffect(() => {
        console.log('image preview', imagePreview);
    }, [imagePreview]);

    useEffect(() => {
        // Only clear preview when value is explicitly empty/reset (not when files are selected)
        const isValueEmpty = (Array.isArray(value) && value.length === 0) || value === '' || value === null || value === undefined;
        if (isValueEmpty) {
            if (inputRef.current) {
                inputRef.current.value = null;
            }
            setImagePreview([]);
            setSelectedFilesSource([]);
        }
    }, [value]);
    return (
        <div className={`my-6 ${className}`}>
            {label && <Label text={label} required={required} info={info} />}
            {isFigmaType && (
                <div ref={dragarea} className="flex items-center justify-center w-full rounded-md cursor-pointer hover:border-gray-600 transition p-3" style={{ border: `1px dashed #9099A1`, marginTop: `13px` }} onDragOver={(e) => {
                    dragarea.current.style.borderColor = `#2b5a2e`; // Change border color on drag over
                    e.preventDefault(); // Required to allow drop                             
                }} onDrop={(e: any) => {
                    e.preventDefault();
                    dragarea.current.style.borderColor = `#9099A1`; // Change border color on drag over
                    const files: any = e.dataTransfer.files;
                    if (files) {
                        // Clear preview if not retaining files
                        if (!retainFiles) {
                            setImagePreview([]);
                        }
                        
                        let sourcefiles: any = retainFiles ? [...selectdFilessource] : [];
                        let refinesourcefiles: any = [];
                        
                        for (let i = 0; i < files.length; i++) {
                            console.log('file type-----', files[i].type);
                            let file = files[i];
                            var ext = file.name.split('.').pop();

                            if (allowedExt.length > 0 && !allowedExt.includes(ext.toLowerCase())) {
                                toast.error(`${file.name} - File type not allowed. Allowed types are: ${allowedExt.join(', ')}`);
                                continue; // Skip this file
                            }

                            if (!validateFileSize(file)) {
                                continue; // Skip this file
                            }

                            if (file.type.startsWith('image/')) {
                                console.log('file is image');
                                let reader: any = new FileReader();
                                reader.onloadend = () => {
                                    setImagePreview(prev => [...prev, { name: file.name, mimetype: file.type, ext: file.name.split('.').pop(), src: reader.result }]);
                                };
                                reader.readAsDataURL(file);
                            } else {
                                console.log('file is not image');
                                setImagePreview(prev => [...prev, { name: file.name, mimetype: file.type, ext: ext, src: null }]);
                            }
                            refinesourcefiles.push(file);
                        }
                        sourcefiles = [...sourcefiles, ...refinesourcefiles];
                        console.log('source files after drop', sourcefiles);
                        setSelectedFilesSource(sourcefiles)
                        onChange({ target: { files: sourcefiles } }, sourcefiles);
                    }
                }}>
                    <div className="text-gray-600 flex items-center justify-between grow">
                        <Button theme={`light`} className={`text-center`} customstyle={{ width: `50%`, height: `44px` }} childstyle={{ justifyContent: `center`, fontSize: `15px`, fontWeight: `normal` }} onClick={() => {
                            if (inputRef.current) {
                                inputRef.current.click();
                            }
                        }}>Upload</Button>
                        {/*
                        <div style={{ width: `50%`, color: `#757C84`, textAlign: `center`, fontSize: `15px` }}>or Drop Files</div>
                        */}
                        {(() => {
                            if (isMobileDevice() && isCameraAvailable && useEmbedMobileCam) {
                                return (
                                    <Button theme={`light`} className={`text-center`} customstyle={{ marginLeft: `25px`, width: `50%`, height: `44px` }} childstyle={{ justifyContent: `center`, fontSize: `15px`, fontWeight: `normal` }} onClick={() => {
                                        if (cameramodalRef.current) {
                                            cameramodalRef.current.open();
                                        }
                                    }}>Use Camera</Button>
                                );
                            } else {
                                return <div style={{ width: `50%`, color: `#757C84`, textAlign: `center`, fontSize: `15px` }}>or Drop Files</div>
                            }
                        })()}
                    </div>
                </div>
            )}
            <input
                ref={inputRef}
                type="file"
                multiple={isMulti}
                placeholder={placeholder}
                onChange={(e: any) => {
                    const files = e.target.files

                    if (files) {
                        // Clear preview if not retaining files
                        if (!retainFiles) {
                            setImagePreview([]);
                        }
                        
                        let sourcefiles: any = retainFiles ? [...selectdFilessource] : [];
                        let refinesourcefiles: any = [];
                        
                        for (let i = 0; i < files.length; i++) {
                            console.log('file type-----', files[i].type);
                            let file = files[i];
                            var ext = file.name.split('.').pop();
                            if (allowedExt.length > 0 && !allowedExt.includes(ext.toLowerCase())) {
                                toast.error(`${file.name} - File type not allowed. Allowed types are: ${allowedExt.join(', ')}`);
                                continue; // Skip this file
                            }

                            if (!validateFileSize(file)) {
                                continue; // Skip this file
                            }
                            if (file.type.startsWith('image/')) {
                                let reader: any = new FileReader();
                                reader.onloadend = () => {
                                    console.log('reader result', reader.result);
                                    setImagePreview(prev => [...prev, { name: file.name, mimetype: file.type, ext: file.name.split('.').pop(), src: reader.result }]);
                                };
                                reader.readAsDataURL(file);
                            } else {
                                // Use functional update for non-image files too
                                setImagePreview(prev => [...prev, { name: file.name, mimetype: file.type, ext: ext, src: null }]);
                            }
                            refinesourcefiles.push(file);
                        }
                        sourcefiles = [...sourcefiles, ...refinesourcefiles];
                        setSelectedFilesSource(sourcefiles)
                        onChange({ target: { files: sourcefiles } }, sourcefiles);
                    }
                }}
                accept={accept}
                disabled={disabled}
                className={`pl-4 py-2  ${error ? 'border-red-500 border-2' : 'border-[#CECECE] border'} rounded-md focus:outline-none  focus:primary text-[0.938rem] mt-2 font-normal min-h-[2.875rem] text-[#656565] w-full placeholder:text-[#656565]`}
                style={isFigmaType ? { display: `none` } : {}}
            />

            {isFigmaType ? (
                <div className={`flex flex-wrap gap-2 mt-2`}>
                    {imagePreview.length > 0 && (
                        <div style={{ borderRadius: `8px`, overflow: `hidden` }} className={`w-full border-collapse border border-gray-300`}>
                            <table style={{ width: '100%' }} className={`table-auto`}>
                                <thead>
                                    <tr style={{ backgroundColor: '#F0F0F0' }}>
                                        <th className={`text-left text-[0.813rem] font-medium`} style={{ padding: `8px 10px` }}>File Name</th>
                                        <th className={`text-right text-[0.813rem] font-medium`}>File type</th>
                                        <th className={`text-right text-[0.813rem] font-medium`}>Extension</th>
                                        <th className={`text-right text-[0.813rem] font-medium`}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {imagePreview.map((img: any, i: number) => (
                                        <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#FFFFFF' : '#F6F6F6' }}>
                                            <td className={`text-[0.813rem]`} style={{ padding: `5px 10px` }}>
                                                <div className={`flex items-center gap-2 font-normal`}>
                                                    {[`png`, `jpg`, `jpeg`, `gif`, `webp`].includes(img.ext.toLowerCase()) ? (
                                                        <div className='rounded-md' style={{ backgroundImage: `url(${img.src})`, backgroundSize: 'cover', backgroundPosition: 'center', width: 42, height: 42 }}></div>
                                                    ) : (
                                                        <Icon name='file' size={2} className='text-[#656565]' />
                                                    )}
                                                    <div>{img.name}</div>
                                                </div>
                                            </td>
                                            <td className={`text-right text-[0.813rem] font-normal`} style={{ padding: `5px 10px` }}>{img.mimetype}</td>
                                            <td className={`text-right text-[0.813rem] font-normal`} style={{ padding: `5px 10px` }}>{img.ext.toUpperCase()}</td>
                                            <td className={`text-right`} style={{ padding: `5px 10px` }}>
                                                <button
                                                    type="button"
                                                    onClick={() => removeFile(i)}
                                                    className="text-red-500 hover:text-red-700 p-1 rounded hover:bg-red-50"
                                                    title="Remove file"
                                                >
                                                    <Icon name='delete' size={1.2} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            ) : (
                <div className='flex flex-wrap gap-2 mt-2'>
                    {imagePreview.length > 0 ? imagePreview.map((img: any, i: number) => (
                        <React.Fragment key={i}>
                            {img && (
                                img.src ? (
                                    <div className='relative w-[90px] h-[90px] rounded-md group' style={{ backgroundImage: `url(${img.src})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                        <button
                                            type="button"
                                            onClick={() => removeFile(i)}
                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
                                            title="Remove image"
                                        >
                                            <Icon name='close' size={0.8} />
                                        </button>
                                    </div>
                                ) : (
                                    <div className='relative group'>
                                        <Icon name='file' size={4} className='text-[#656565]' />
                                        <button
                                            type="button"
                                            onClick={() => removeFile(i)}
                                            className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
                                            title="Remove file"
                                        >
                                            <Icon name='close' size={0.8} />
                                        </button>
                                    </div>
                                )
                            )}
                        </React.Fragment>
                    )) :
                        <>
                            {Array.isArray(value) && value.length > 0 &&
                                value.map((img: any, i: number) => (
                                    <>
                                        {typeof img == 'string' &&
                                            <div key={i} className='w-full h-[150px] rounded-md' style={{ backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                                        }
                                    </>
                                ))
                            }
                            {typeof value == 'string' && value !== '' &&
                                <div className='w-full h-[150px] rounded-md ' style={{ backgroundImage: `url(${value})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                            }
                        </>
                    }

                </div>
            )}
            {error && <Error message={error} />}
            <ModalWrapper ref={cameramodalRef} showCloseBtn={false}>
                <Camera onCancel={() => {
                    cameramodalRef.current?.close();
                }} onSubmit={(resp) => {
                    console.log("Camera Processed File is -> ", resp);
                    if (resp.file) {
                        let preview: any = retainFiles ? [...imagePreview] : [];
                        let sourcefiles: any = retainFiles ? [...selectdFilessource] : [];
                        let refinesourcefiles: any = [];
                        preview = [...preview, { name: resp.file.name, mimetype: resp.file.type, ext: resp.file.name.split('.').pop(), src: resp.uridata }];
                        setImagePreview(preview);
                        refinesourcefiles.push(resp.file);

                        sourcefiles = [...sourcefiles, ...refinesourcefiles];
                        setImagePreview(preview);
                        setSelectedFilesSource(sourcefiles)
                        onChange({ target: { files: sourcefiles } }, sourcefiles);
                    }
                    cameramodalRef.current?.close();
                }} />
            </ModalWrapper>
        </div>
    );
};

export default FileUpload;